import range from 'lodash-es/range'

import { EMPTY_LIST } from '../../../../constants/common'
import { CALENDAR_GRID_EMPTY_COUNT } from '../../CalendarGrid.constants'
import { getIsCalendarGridMultiDayItem } from '../../CalendarGrid.utils'

import { CALENDAR_GRID_WEEK_FIRST_DAY_INDEX } from './CalendarGridWeekAllDay.constants'

function getIsCalendarGridWeekSpanItem({ firstDay, item, lastDay }) {
  const isStartedByWeekEnd = item.date <= lastDay
  const isEndedAfterWeekStart = item.lastDate >= firstDay

  return (
    getIsCalendarGridMultiDayItem(item) &&
    isStartedByWeekEnd &&
    isEndedAfterWeekStart
  )
}

function compareCalendarGridWeekSpanItems(first, second) {
  return (
    first.date.localeCompare(second.date) ||
    second.lastDate.localeCompare(first.lastDate)
  )
}

function getIsCalendarGridSpanOnDays({ endIndex, span, startIndex }) {
  const isStartedByLastDay = span.startIndex <= endIndex
  const isEndedAfterFirstDay = span.endIndex >= startIndex

  return isStartedByLastDay && isEndedAfterFirstDay
}

function getCalendarGridFreeSpanTrack({ endIndex, spans, startIndex }) {
  return range(spans.length + 1).find(
    track =>
      !spans.some(
        span =>
          span.track === track &&
          getIsCalendarGridSpanOnDays({ endIndex, span, startIndex })
      )
  )
}

function getCalendarGridWeekSpansWithItem({
  dayIndexes,
  item,
  lastDayIndex,
  spans,
}) {
  const startIndex = dayIndexes[item.date] ?? CALENDAR_GRID_WEEK_FIRST_DAY_INDEX
  const endIndex = dayIndexes[item.lastDate] ?? lastDayIndex

  return [
    ...spans,
    {
      endIndex,
      item,
      startIndex,
      track: getCalendarGridFreeSpanTrack({ endIndex, spans, startIndex }),
    },
  ]
}

export function getCalendarGridWeekSpans({ days, items }) {
  const dayIndexes = Object.fromEntries(
    days.map((day, index) => [day.date, index])
  )

  const lastDayIndex = days.length - 1

  const firstDay = days[0].date
  const lastDay = days[lastDayIndex].date

  return items
    .filter(item => getIsCalendarGridWeekSpanItem({ firstDay, item, lastDay }))
    .sort(compareCalendarGridWeekSpanItems)
    .reduce(
      (spans, item) =>
        getCalendarGridWeekSpansWithItem({
          dayIndexes,
          item,
          lastDayIndex,
          spans,
        }),
      EMPTY_LIST
    )
}

export function getCalendarGridDaySpanTrackCount({ dayIndex, spans }) {
  return spans.reduce(
    (count, span) =>
      getIsCalendarGridSpanOnDays({
        endIndex: dayIndex,
        span,
        startIndex: dayIndex,
      })
        ? Math.max(count, span.track + 1)
        : count,
    CALENDAR_GRID_EMPTY_COUNT
  )
}
